<template>
        <div  >
            <Toast />
            <AdminIndex v-if="isAdmin || isSubAffiliate" />
            <UserIndex v-else />
        </div>
</template>
<script setup>
import { computed } from "vue";
import { useStore } from 'vuex';

import AdminIndex from '../Publishers/AdminIndex.vue';
import UserIndex from './UserIndex.vue';

const store = useStore();
const isAdmin = computed(() => store.getters.isAdmin);
const isSubAffiliate = computed(() => store.getters.isSubAffiliate);

</script>

<style scoped>
</style>